import { Link } from 'react-router-dom';

export default function ContactHero() {
  return (
    <section className="relative pt-32 pb-20 overflow-hidden">
      <div className="absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-r from-forest-green to-deep-black"></div>
        <div className="absolute inset-0 bg-gradient-to-b from-transparent via-deep-black/50 to-deep-black"></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Breadcrumb */}
        <nav className="flex items-center gap-2 text-sm text-gray-400 mb-8">
          <Link to="/" className="hover:text-copper transition-colors duration-200 cursor-pointer">
            Home
          </Link>
          <i className="ri-arrow-right-s-line"></i>
          <span className="text-copper">Contact</span>
        </nav>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h1 className="font-serif text-5xl lg:text-7xl text-white mb-6">
              Get in <span className="text-copper">Touch</span>
            </h1>
            <div className="w-16 h-0.5 bg-copper mb-8"></div>
            <p className="text-gray-300 text-xl leading-relaxed mb-8">
              Have questions? Want to learn more about our products? We're here to help. Visit us in Eustis or reach out today.
            </p>
            <div className="flex flex-wrap gap-4">
              <a
                href="tel:+13529774832"
                className="inline-flex items-center gap-2 px-6 py-3 bg-copper text-deep-black font-semibold rounded-full hover:bg-copper/90 transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line"></i>
                Call Us Now
              </a>
              <a
                href="https://www.google.com/maps/dir/?api=1&destination=1321+S+Bay+St,+Eustis,+FL+32726"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center gap-2 px-6 py-3 border-2 border-copper text-copper font-semibold rounded-full hover:bg-copper hover:text-deep-black transition-all duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-map-pin-line"></i>
                Get Directions
              </a>
            </div>
          </div>

          {/* Right Image */}
          <div className="relative hidden lg:block">
            <div className="relative w-full h-[400px] rounded-2xl overflow-hidden">
              <img
                src="https://static.readdy.ai/image/4f6582e073a5efa66fcf915170e338fb/cd636f0820153fa8e1cae0135d02e72a.jpeg"
                alt="High Standards Smoke Shop Storefront"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-deep-black/60 via-transparent to-transparent"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
